import axios from "../utils/axios";

export function signIn(credentials) {
    var bodyFormData = new FormData();
    bodyFormData.append('username', credentials.email);
    bodyFormData.append('password', credentials.password);

    return new Promise((resolve, reject) => {
        axios
            .post("/api/external_login", bodyFormData)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function signUp(credentials) {
    return new Promise((resolve, reject) => {
        axios
            .post("/api/auth/sign-up", credentials)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function resetPassword(credentials) {
    return new Promise((resolve, reject) => {
        axios
            .post("/api/auth/reset-password", credentials)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
